import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyAlertBar() {
  const [isVisible, setIsVisible] = useState(true);
  return <AnimatePresence data-id="element-189">
      {isVisible && <motion.div initial={{
      y: -40
    }} animate={{
      y: 0
    }} exit={{
      y: -40
    }} className="fixed top-0 left-0 right-0 h-10 bg-primary text-white z-50 flex items-center justify-center px-4 shadow-md" data-id="element-190">
          <p className="text-sm md:text-base font-medium text-center truncate pr-6" data-id="element-191">
            🔥 SOLO POR HOY 4 BONOS GRATIS 🔥
          </p>
          <button onClick={() => setIsVisible(false)} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full transition-colors" aria-label="Cerrar alerta" data-id="element-192">
            <X size={16} data-id="element-193" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}